export default __webpack_public_path__ + "static/media/screen_livechat_07.4b537846.png";